import {
  TRANSLATE_ARCHIVE_TYPE,
  displayRecordingTranscriptText,
} from "@/lib/sharedApiTypes";

export type TranslateArchiveDisplay = {
  displayText: string;
  rawText: string;
};

export function translateArchiveDisplay(text: string): TranslateArchiveDisplay | null {
  try {
    const value: unknown = JSON.parse(text);
    if (
      value === null ||
      typeof value !== "object" ||
      Array.isArray(value) ||
      !("type" in value) ||
      value.type !== TRANSLATE_ARCHIVE_TYPE
    ) {
      return null;
    }

    return {
      displayText: displayRecordingTranscriptText(text),
      rawText: text,
    };
  } catch {
    return null;
  }
}
